import RightTimeApi from "@/API";
import type { ContentLanguageVersion, ContentVersionHistoryScope } from "@/utils/contentVersionHistory";

type SaveContentVersionNoteArgs = {
  historyType: ContentVersionHistoryScope;
  historyId: number;
  changeNote: string;
};

export async function saveContentVersionNoteAsync({
  historyType,
  historyId,
  changeNote,
}: SaveContentVersionNoteArgs): Promise<ContentLanguageVersion | null> {
  const resp = await RightTimeApi.putAsync("/ContentLanguageHistory/Note", {
    historyType,
    historyId,
    changeNote,
  });

  if (!resp?.ok) {
    return null;
  }

  const payload = (resp.jsonData ?? resp.value ?? null) as Record<string, unknown> | null;
  if (!payload || typeof payload !== "object") {
    return null;
  }

  const id = Number(payload.id ?? payload.Id ?? 0);
  if (!Number.isFinite(id) || id <= 0) {
    return null;
  }

  return {
    id,
    changedAt: String(payload.changedAt ?? payload.ChangedAt ?? ""),
    changedByUserId: Number(payload.changedByUserId ?? payload.ChangedByUserId ?? 0) || null,
    changedByName: String(payload.changedByName ?? payload.ChangedByName ?? "System"),
    changeNote: String(payload.changeNote ?? payload.ChangeNote ?? "") || null,
    content: typeof payload.content === "string" ? payload.content : undefined,
    title: typeof payload.title === "string" ? payload.title : undefined,
    detailContent: typeof payload.detailContent === "string" ? payload.detailContent : undefined,
  };
}
